import CodeEditor from '@/components/code-editor/code-editor.vue';

export default {
  name: 'PanelItemEdit',
  props: {
    panelName: String,
  },
  components: {
    CodeEditor,
  },
  methods: {
    saveContent(content) {
      console.log('PanelItemEdit', content);
    },
  },
};
